<script>
  export let title, // facet header
    attribute, // must match search facets attribute
    search, // algolia index search result
    facets, // track facets across searches, bind:facets in parent
    page, // current page, bind:page in parent
    action;
  const handleFacet = (e) => {
    const name = e.target.attributes.name.value,
      checked = e.target.checked;
    if (checked) facets = Array.from(new Set([...facets, name]));
    else facets = facets.filter((x) => x != name);
    page = 0;
    action();
  };
</script>

<h6>{title}</h6>
{#if attribute in search.facets}
  {#each Object.entries(search.facets[attribute]) as facet}
    <div>
      <input
        type="checkbox"
        class="checkbox"
        on:change={handleFacet}
        name={`${attribute}:"${facet[0]}"`}
        checked={facets.includes(`${attribute}:"${facet[0]}"`)}
      />
      {facet[0]} ({facet[1]} hits)
    </div>
  {/each}
{/if}
<br />
